import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import PortalLogin from "@/pages/PortalLogin";
import FieldDashboard from "@/pages/FieldDashboard";
import ShopDashboard from "@/pages/ShopDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading...</div>;
  if (!user) return <Navigate to="/portal" replace />;
  const home = user.role === "admin" ? "/admin" : user.role === "shop_worker" ? "/shop" : "/field";
  if (role && user.role !== role) return <Navigate to={home} replace />;
  return children;
}

function PortalLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/products" element={<PublicLayout><Products /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/portal" element={<PortalLayout><PortalLogin /></PortalLayout>} />
            <Route path="/field" element={<Protected role="field_worker"><PortalLayout><FieldDashboard /></PortalLayout></Protected>} />
            <Route path="/shop" element={<Protected role="shop_worker"><PortalLayout><ShopDashboard /></PortalLayout></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><PortalLayout><AdminDashboard /></PortalLayout></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
